import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import IntelligenceOnboarding from "@/pages/IntelligenceOnboarding";

export const Route = createFileRoute("/_app/intelligence/onboarding")({
  component: () => (
    <PageGate pageKey="intelligence"><IntelligenceOnboarding /></PageGate>
  ),
});
